var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 46,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 18h2v28H9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19 1v8.586l-9 9-9-9V1h18z"
})));
export default SvgMarker;